"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvernightPostcodeWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../components/infoQuestion/InfoQuestionWrapper");
var OvernightPostcodeWidget = exports.OvernightPostcodeWidget = /** @class */ (function (_super) {
    __extends(OvernightPostcodeWidget, _super);
    function OvernightPostcodeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlurEvent = _this.handleOnBlurEvent.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        _this.state = {
            postcodeFound: false
        };
        if (_this.bindFromField(_this.props.question.interactionField)) {
            _this.props.onStateChange("uistate.overnightPostcodeFound", true);
            _this.validateInternal(_this.bindFromField(_this.props.question.interactionField));
        }
        return _this;
    }
    OvernightPostcodeWidget.prototype.render = function () {
        var label = this.props.question.label ? React.createElement("label", null, this.props.question.label) : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.getSetting("infoHtml") ? this.renderHtml(this.getSetting("infoHtml")) : null;
        if (info) {
            return (React.createElement(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), className: this.getSetting("cssClass") }, _super.prototype.render.call(this)));
        }
        else {
            return _super.prototype.render.call(this);
        }
    };
    OvernightPostcodeWidget.prototype.renderInputField = function () {
        var props = {
            type: "text",
            className: "form-control ".concat(this.getInputValidationClass()),
            id: this.props.question.name,
            value: this.bindFromField(this.props.question.interactionField) || "",
            onChange: this.handleOnChangeEvent,
            onFocus: this.executeAndRecordNativeEvent,
            onBlur: this.handleOnBlurEvent,
            onClick: this.executeNativeEvent,
            onDoubleClick: this.executeNativeEvent,
            readOnly: this.isReadOnly
        };
        return React.createElement("input", __assign({}, props));
    };
    OvernightPostcodeWidget.prototype.handleOnChangeEvent = function (event) {
        event.target.value = event.target.value.toUpperCase();
        this.executeAndRecordNativeEvent(event);
        this.postcodeExists(event.target.value);
    };
    OvernightPostcodeWidget.prototype.postcodeExists = function (postcode) {
        var _this = this;
        this.falconConvenienceApiService.postcodeExists(postcode.replace(/ /g, ''))
            .subscribe(function (output) {
            _this.props.onStateChange("uistate.overnightPostcodeFound", output);
            _this.validateInternal(postcode);
        });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], OvernightPostcodeWidget.prototype, "falconConvenienceApiService", void 0);
    return OvernightPostcodeWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=OvernightPostcodeWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/OvernightPostcodeWidget.js
// module id = 3437
// module chunks = 0